import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallReasonReportSlice = (set, get) => ({
    crmCallReasonReport: {
        loading: false,
        data: [],
    },
    getCrmCallReasonReport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallReasonReport: { ...state.crmCallReasonReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/crm/call-reasons',
                headers: { token }
            });
            set(state => ({ crmCallReasonReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallReasonReport: { ...state.crmCallReasonReport, loading: false } }));
        }
    }
});
